import { useTranslation } from 'next-i18next';

import { alertDialog } from '@/ui_v3';

export const useBuildQuestionAlert = () => {
  const { t } = useTranslation(['build']);

  const openQuestionCountLimitAlert = () => {
    alertDialog.open({
      header: {
        title: t('build:build.alert.quizLimit'),
      },
    });
  };

  const openQuestionSaveSuccessAlert = () => {
    alertDialog.open({
      header: {
        title: t('build:ai.addQuiz.success'),
      },
    });
  };

  const openQuestionCountLimitDetailedAlert = (
    totalLimit: number,
    currentLimit: number,
  ) => {
    alertDialog.open({
      header: {
        title: t('build:build.ai.countExceed'),
      },
      body: t('build:build.ai.countExceedDescription', {
        totalLimit,
        currentLimit,
      }),
    });
  };

  return {
    openQuestionCountLimitAlert,
    openQuestionSaveSuccessAlert,
    openQuestionCountLimitDetailedAlert,
  };
};
